/*
 * @Author: cc
 * @LastEditTime: 2022-06-17 17:21:06
 */
import { useEffect, useState } from "react";
// import { IsPc } from "../utils/index";
import Style from "./index.module.scss"
import "moment/locale/zh-cn";
import { useLocation, useHistory } from "react-router-dom";
// import {get} from "../component/fetch"
import store from '../../reducers/index'
// import logo from "../../img/logo.png"
import Login from "../component/login"
import SignUp from "../component/signupModal";
import { post, get } from "../../component/fetch"
import { AppstoreOutlined } from "@ant-design/icons"
import { connect } from "react-redux"
import { Button, Space, Tabs, List, message, Modal } from "antd";
import type { TabsProps } from 'antd';
import { IsPc } from "src/utils"
import QRCode from 'qrcode.react';
import moment from "moment";
// import { message } from "antd";
export const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};
export interface Category {
  zhName: string;
  enName: string;
  required: boolean;
  fieldType: string;
  tips?: string;
  placeholder?: string;
  selectOptions: string[];
  id: number;
}
const Index = (props: any) => {
  const query = useQuery()
  const history = useHistory();
  const columnId = query.get('columnId') || ''
  const subjectId = query.get('subjectId') || ''
  // const watchType = query.get('watchType') || ''
  // const [loginView, setLoginView] = useState(false)
  // const [signupView, setSignView] = useState(false)
  const [shareModal, setShareModal] = useState(false)
  const [subscriptionModal,setSubscriptionModal] = useState(false)
  const [list, setList] = useState([{ id: 0, name: '第一期' }])
  const [loading, setLoading] = useState(false)
  // const columnInfo = store.getState().InitPageData || {}
  const jump = (item: any) => {
    // if(!userInfo.userId){
    //   message.warning('请先登录')
    //   setLoginView(true)
    // }else{
    //   // setSignView(true)
    //   history.push(`/project?columnId=${columnId}&subjectId=${subjectId}`)
    // }
    history.push(`/project?columnId=${columnId}&subjectId=${item.id}`)
  }
  // const SignUpClick = () => {
  //   // if(!userInfo.userId){
  //   //   message.warning('请先登录')
  //   //   setLoginView(true)
  //   // }else{
  //   //   //判断是否报名

  //   //   setSignView(true)
  //   // }
  //   history.push(`/project?columnId=${columnId}&subjectId=${props.columnInfo.id}`)
  // }
  // const getColumnDetail = () => {
  //   get('/shop/front/ge/column/subject/getDetail2?subjectId='+ subjectId + (watchType ? '&watchType='+ watchType : ''),{},false).then(res=>{
  //       setColumnInfo(res.data)
  //       store.dispatch({
  //         type: "SET_INIT_PAGE_INFO",
  //         ...res.data
  //       })
  //   })
  // }

  function UrlQRCode({url}:any) {
    return <QRCode value={url} />;
  }
  const onChange = (key: string) => {
    key === "2" && getThemList()
  };
  const getThemList = () => {
    setLoading(true)
    post('/shop/front/ge/column/subject/getList', { columnId, subjectId: subjectId ? subjectId : null }, false).then(res => {
      if (res.code === 0) {
        setList(res.data.list)
      }
      setLoading(false)
    }).catch(() => {
      setLoading(false)
    })
  }
  function getColumnDetail() {
    get('/shop/front/ge/getColumnDetail?columnId=' + columnId + '&subjectId=' + subjectId , {}, false).then(res => {
      store.dispatch({
        type: "SET_INIT_PAGE_INFO",
        ...res.data
      })
      document.title = res.data.titleName
    })
  }
  const IntroductionPage = () => {
    return <p dangerouslySetInnerHTML={{ __html: props.columnInfo?.content }}></p>
  }
  useEffect(()=>{
    getColumnDetail()
  },[])
  const MenuPage = () => {
    return <div className={Style.menuPage}>
      <List
        itemLayout="horizontal"
        dataSource={list}
        loading={loading}
        renderItem={(item: any, index) => (
          <List.Item >
            <div className={Style.listItem} onClick={()=>jump(item)}>
              <img src={item.logoUrl} alt=""></img>
              {/* <span className={Style.orderNum}>NO.{item.orderNum}期</span> */}
              <div>
                <h3>{item.titleName}</h3>
                <h3>{item.hostUnit}</h3>
                <p>开放时间: {moment(item.openTimeBegin).format('YYYY-MM-DD')} - {moment(item.openTimeEnd).format('YYYY-MM-DD')}</p>
                <span className={item.runStatus === "进行中" ? Style.select : Style.unfinished}>{item.runStatus}</span>
              </div>
            </div>
          </List.Item>
        )}
      />
    </div>
  }
  const items: TabsProps['items'] = [
    {
      key: '1',
      label: '介绍',
      children: <IntroductionPage />,
    },
    {
      key: '2',
      label: '目录',
      children: <MenuPage></MenuPage>,
    },
  ];
  useEffect(()=>{
  },[])
  return (
    <>
      <div
        className="App"
      >
        <div className={Style.wrapper}>
          <div className={Style.banner}>
            <img src={props.columnInfo ? props.columnInfo.logoUrl : ''}  alt=""></img>
            <div className={Style.content}>
              <h2>{props.columnInfo?.titleName}</h2>
              <p >{props.columnInfo?.orderNumTotal}</p>
              <div className="pos-a pos-l20 pos-b20">
                {props.columnInfo.trainFileLongUrl&&<div>
                  <Button type="primary" onClick={() =>{
                    window.open("/shop/front/ge/getColumnTrainFileInfo?fileUrl="+props.columnInfo?.trainFileLongUrl)
                  }}>培训通知</Button>
                </div>}
                <Button className={Style.btnYellow} onClick={() => setSubscriptionModal(true)}>栏目订阅</Button>
                <Button className={Style.btnYellow} onClick={() => setShareModal(true)}>分享</Button>
              </div>
            </div>
          </div>
          {/* <h3 style={{marginTop:"20px"}} className="mt20">{props.columnInfo.titleName}</h3>
              <button className={Style.myBtns} onClick={SignUpClick}>立即观看</button> */}
          {/* <div style={{marginTop:"20px"}}>
                <div style={{textAlign:"left",color:"#999999",fontSize:"20px"}}><AppstoreOutlined style={{marginRight:"10px"}}/>往期主题</div>
                <div className={Style.theme_content}>
                  {list.map((item:any,index:number)=>{
                    return <div key={index} onClick={()=>jump(item)} style={{backgroundImage:`url(${item.logoUrl})`,backgroundSize:"100% 100%",color:"#fff",fontWeight:"bolder"}}></div>
                  })}
                </div>
              </div> */}
          <div className={Style.contentBox}>
            <Tabs className={Style.myTabs} defaultActiveKey="1" items={items} onChange={onChange}></Tabs>
          </div>
          <Modal open={shareModal} footer={null} onCancel={()=>setShareModal(false)}>
            <div className="flex ac flex-column " style={{paddingBottom:"50px"}}>
              <h2 className="tc">微信分享</h2>
              <p className="c-999">打开微信“扫一扫”，打开网页后点击屏幕右上角分享按钮</p>
              <UrlQRCode url={props.columnInfo?.mobileWatchUrl}/>
            </div>
          </Modal>
          <Modal open={subscriptionModal} footer={null} onCancel={()=>setSubscriptionModal(false)}>
            <div className="flex ac flex-column " style={{paddingBottom:"50px"}}>
              <h2 className="tc">订阅通知</h2>
              <p className="c-999">打开微信“扫一扫”，使用微信完成订阅</p>
              <UrlQRCode url={props.columnInfo?.mobileWatchUrl}/>
            </div>
          </Modal>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state: any) => ({
  columnInfo: state.InitPageData, // 映射仓库中的某个变量到组件的props
});
export default connect(mapStateToProps)(Index);
